import { KeyboardArrowDown } from "@mui/icons-material";
import { Typography } from "@mui/material";

import AutoCompleteDropdown from "../../../../../../ui library/components/dropdowns/AutoCompleteDropdown";
import HNSColors from "../../../../../../ui library/HNSColors";
import { useProviderTypes } from "../../../hooks/useProviderTypes";
import { STYLES } from "../../../utils/customStyles";
import CustomListBox from "../CustomListBox";

const renderChips =
  ({ minReached }) =>
  (value, getTagProps) =>
    value.map((option, index) => {
      const { key, onDelete, ...tagProps } = getTagProps({ index });
      const disableDelete = minReached && value.length === 1;

      return (
        <div
          key={key}
          {...tagProps}
          className="flex items-center gap-2 px-2"
          style={{
            backgroundColor: HNSColors.secondary[900],
            borderRadius: "500px",
            opacity: disableDelete ? 0.6 : 1,
          }}
        >
          <Typography className="text-[12px] font-normal" sx={{ color: HNSColors.secondary[400] }}>
            {option.label}
          </Typography>

          <span
            onClick={disableDelete ? undefined : onDelete}
            className="text-[14px]"
            style={{
              color: HNSColors.secondary[400],
              cursor: disableDelete ? "not-allowed" : "pointer",
            }}
          >
            ×
          </span>
        </div>
      );
    });

const getHelperText = ({ minReached, maxReached, min, max }) => {
  if (minReached) {
    return `At least ${min} provider types must be selected.`;
  }
  if (maxReached) {
    return `Maximum of ${max} provider types can be selected.`;
  }
  return "";
};

export default function ProviderTypeSearchField({
  placeholder = "",
  fieldName,
  fieldValue = [],
  onChange = () => {},
}) {
  const { data, min, max, setSearch, loading, showMore, handleShowMore } = useProviderTypes();

  const options = data.map(({ id, label }) => ({ id, label }));

  const maxReached = fieldValue.length >= max;
  const minReached = fieldValue.length <= min;

  return (
    <AutoCompleteDropdown
      multiple
      size="small"
      data={options}
      initValue={fieldValue}
      placeholder={placeholder}
      loading={loading}
      getOptionLabel={(o) => o?.label || ""}
      isOptionEqualToValue={(o, v) => o.id === v.id}
      getOptionDisabled={(option, selected) =>
        maxReached && !selected.some((v) => v.id === option.id)
      }
      renderTags={renderChips({ minReached })}
      onValueChange={(_, value) => onChange(fieldName, value)}
      onInputChange={(_, value) => !maxReached && setSearch(value)}
      ListboxComponent={CustomListBox}
      ListboxProps={{
        showMore,
        setShowMore: handleShowMore,
        sx: { maxHeight: 200, overflow: "auto" },
      }}
      dropdownSx={STYLES.selectMenuPaper}
      popupIcon={<KeyboardArrowDown sx={{ color: HNSColors.primary[500] }} />}
      textFieldSx={{
        ...STYLES.textField,
        "& .MuiAutocomplete-inputRoot": {
          display: "flex",
          flexWrap: "wrap",
          gap: "6px",
          padding: "6px",
        },
      }}
      helperText={getHelperText({ minReached, maxReached, min, max })}
    />
  );
}
